import { get, head, isFinite, sortBy } from 'lodash-es'

import { getLinkUrlOfType, getLinkAllowedOfType } from '@/js/helper/links-helper.js'
import { basketAddressCompare } from '@/js/helper/aimeos-basket-address-helper'
// import { getCustomerDeliveryAdress } from '@/js/helper/aimeos-customer-address-helper'
import { formatDeliveryAddress } from '@/js/helper/aimeos-basket-address-helper.js'
import { CHECKOUT_CONSTANTS } from '../constants/checkout-constants'
import {
  COMPANY_CODE_TO_BRAND,
  CLIENT_TO_COMPANY_CODE,
} from '@/js/helper/dp-usermanagement-constants.js'

import API_CONSTANTS from '@/js/helper/api-constants.js'
import GETTER_TYPES from '../getter-types'
// Todo: Use Rebate
export const getBasketGetters = MUTATION_TYPES => ({
  [GETTER_TYPES.BASKET_PROMISE]: state => get(state, MUTATION_TYPES.BASKET.promiseKey),
  [GETTER_TYPES.BASKET_REQUEST_COUNT]: state => get(state, MUTATION_TYPES.BASKET.requestCount),
  [GETTER_TYPES.BASKET]: state => get(state, [MUTATION_TYPES.BASKET.dataKey], {}),
  [GETTER_TYPES.BASKET_PRICE]: state => {
    const price = get(state, [[MUTATION_TYPES.BASKET.dataKey], 'price'], 0)
    return isFinite(price) ? price : 0
  },
  [GETTER_TYPES.BASKET_COUNT]: state => get(state, [[MUTATION_TYPES.BASKET.dataKey], 'count'], 0),
  [GETTER_TYPES.BASKET_CURRENCYID]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'currency'], 'EUR'),
  [GETTER_TYPES.BASKET_BASE_ID]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketBaseId']),
  [GETTER_TYPES.BASKET_REFERENCE]: (state, getters) =>
    get(getters[GETTER_TYPES.BASKET_CLIENT_DATA], CHECKOUT_CONSTANTS.REFERENCE, ''),
  [GETTER_TYPES.BASKET_COMMENT]: (state, getters) =>
    get(getters[GETTER_TYPES.BASKET_CLIENT_DATA], CHECKOUT_CONSTANTS.COMMENT, ''),
  [GETTER_TYPES.BASKET_DELIVERY_IS_BILLING_ADDRESS]: (state, getters) => {
    if (getters[GETTER_TYPES.BASKET_DELIVERY_ADDRESS_INCLUDED].length === 0) {
      return undefined
    }
    return basketAddressCompare({
      getters,
      deliveryAddress: getters[GETTER_TYPES.CUSTOMER_PAYMENT_ADDRESS_BASKET],
    })
  },
  [GETTER_TYPES.BASKET_PAYMENT_ADDRESS]: (state, getters) => {
    return get(getters[GETTER_TYPES.BASKET_PAYMENT_ADDRESS_INCLUDED], 0)
  },
  [GETTER_TYPES.BASKET_DELIVERY_ADDRESS]: (state, getters) => {
    if (getters[GETTER_TYPES.BASKET_DELIVERY_IS_BILLING_ADDRESS]) {
      return undefined
    }
    return getters[GETTER_TYPES.CUSTOMER_DELIVERY_ADDRESSES].find(address => {
      // console.log(get(address, API_CONSTANTS.ID))
      // console.log(
      //   get(getters[GETTER_TYPES.BASKET_DELIVERY_ADDRESS_INCLUDED], [
      //     0,
      //     ...API_CONSTANTS.AIMEOS.BASKET_ADDRESS.PATHS.ADDRESS_ID,
      //   ]),
      // )
      return (
        get(address, API_CONSTANTS.ID) ===
        get(getters[GETTER_TYPES.BASKET_DELIVERY_ADDRESS_INCLUDED], [
          0,
          ...API_CONSTANTS.AIMEOS.BASKET_ADDRESS.PATHS.ADDRESS_ID,
        ])
      )
      // basketAddressCompare({ getters, deliveryAddress: getCustomerDeliveryAdress(address) }),
    })
  },
  [GETTER_TYPES.BASKET_DELIVERY_ADDRESS_ID]: (state, getters) => {
    return getters[GETTER_TYPES.BASKET_DELIVERY_ADDRESS]
      ? get(getters[GETTER_TYPES.BASKET_DELIVERY_ADDRESS], API_CONSTANTS.ID)
      : undefined
  },
  [GETTER_TYPES.BASKET_DELIVERY_ADDRESS_FORMATTED]: (state, getters) => {
    return getters[GETTER_TYPES.BASKET_DELIVERY_ADDRESS]
      ? formatDeliveryAddress(getters[GETTER_TYPES.BASKET_DELIVERY_ADDRESS]).formatted
      : undefined
  },
  [GETTER_TYPES.BASKET_PAYMENT_SERVICE_ID]: (state, getters) => {
    if (getters[GETTER_TYPES.BASKET_PAYMENT_SERVICE_INCLUDED].length !== 1) {
      return undefined
    }
    const basketServiceCode = get(head(getters[GETTER_TYPES.BASKET_PAYMENT_SERVICE_INCLUDED]), [
      'attributes',
      'order.base.service.code',
    ])

    const service = getters[GETTER_TYPES.SERVICE_PAYMENT_SERVICES].find(
      service => get(service, API_CONSTANTS.AIMEOS.SERVICE.PATHS.CODE) === basketServiceCode,
    )
    return service ? get(service, API_CONSTANTS.ID) : undefined
  },
  [GETTER_TYPES.BASKET_DELIVERY_SERVICE_ID]: (state, getters) => {
    if (getters[GETTER_TYPES.BASKET_DELIVERY_SERVICE_INCLUDED].length !== 1) {
      return undefined
    }
    const basketServiceCode = get(head(getters[GETTER_TYPES.BASKET_DELIVERY_SERVICE_INCLUDED]), [
      'attributes',
      'order.base.service.code',
    ])

    const service = getters[GETTER_TYPES.SERVICE_DELIVERY_SERVICES].find(
      service => get(service, API_CONSTANTS.AIMEOS.SERVICE.PATHS.CODE) === basketServiceCode,
    )
    return service ? get(service, API_CONSTANTS.ID) : undefined
  },
  // [GETTER_TYPES.BASKET_PRODUCT_RELATIONSHIPS]: state =>
  //   get(
  //     state,
  //     [
  //       [MUTATION_TYPES.BASKET.dataKey],
  //       ...API_CONSTANTS.AIMEOS.BASKET.PATHS.BASKET_PRODUCT_RELATIONSHIPS,
  //     ],
  //     [],
  //   ),
  [GETTER_TYPES.BASKET_INCLUDED]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'included'], []),
  // [GETTER_TYPES.BASKET_PRODUCT_INCLUDED]: state =>
  //   get(state, [[MUTATION_TYPES.BASKET.dataKey], 'products'], []),
  // [GETTER_TYPES.BASKET_BIKE_INCLUDED]: state =>
  //   get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketBikes'], []),
  // [GETTER_TYPES.BASKET_BIKE_GROUPED]: state =>
  //   get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketBikesGrouped'], []),
  // [GETTER_TYPES.BASKET_SPAREPART_GROUPED]: state =>
  //   get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketSparepartsGrouped'], []),
  // [GETTER_TYPES.BASKET_SPAREPART_INCLUDED]: state =>
  //   get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketSpareparts'], []),
  // [GETTER_TYPES.BASKET_BIKE_PRICE]: state =>
  //   get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketBikesPrice'], 0),
  // [GETTER_TYPES.BASKET_SPAREPART_PRICE]: state =>
  //   get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketSparepartsPrice'], 0),
  [GETTER_TYPES.BASKET_CLIENT_PRODUCTS_GROUPED]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'clientProductsGrouped'], {}),
  [GETTER_TYPES.BASKET_CLIENTS]: state =>
    sortBy(
      Object.keys(get(state, [[MUTATION_TYPES.BASKET.dataKey], 'clientProductsGrouped'], {})),
      [
        function (client) {
          return COMPANY_CODE_TO_BRAND[CLIENT_TO_COMPANY_CODE[client]]
        },
      ],
    ),
  [GETTER_TYPES.BASKET_CLIENT_DELIVERY_ADDRESSES]: (state, getters) => {
    return getters[GETTER_TYPES.BASKET_CLIENTS].reduce((acc, client) => {
      acc[client] =
        getters[GETTER_TYPES.BASKET_CLIENT_DATA]?.[client]?.[CHECKOUT_CONSTANTS.DELIVERY_ADDRESS]
      return acc
    }, {})
  },
  [GETTER_TYPES.BASKET_CLIENT_DATA]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketClientData'], {}),
  [GETTER_TYPES.BASKET_CLIENT_DATA_FOR]: state => client =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketClientData', client], {}),
  // [GETTER_TYPES.BASKET_ADDRESS_INCLUDED]: state => get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketAddressIncluded']),
  // [GETTER_TYPES.BASKET_SERVICE_INCLUDED]: state => get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketServiceIncluded']),
  [GETTER_TYPES.BASKET_PAYMENT_ADDRESS_INCLUDED]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketPaymentAddressIncluded'], []),
  [GETTER_TYPES.BASKET_DELIVERY_ADDRESS_INCLUDED]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketDeliveryAddressIncluded'], []),
  [GETTER_TYPES.BASKET_PAYMENT_SERVICE_INCLUDED]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketPaymentServiceIncluded'], []),
  [GETTER_TYPES.BASKET_DELIVERY_SERVICE_INCLUDED]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketDeliveryServiceIncluded'], []),
  // [GETTER_TYPES.BASKET_LINKS]: state =>
  //   get(
  //     state,
  //     [[MUTATION_TYPES.BASKET.dataKey], ...API_CONSTANTS.AIMEOS.BASKET.PATHS.BASKET_LINKS],
  //     [],
  //   ),
  // [GETTER_TYPES.DATA_BASKET_LINKS]: state =>
  //   get(
  //     state,
  //     [[MUTATION_TYPES.BASKET.dataKey], ...API_CONSTANTS.AIMEOS.BASKET.PATHS.DATA_BASKET_LINKS],
  //     [],
  //   ),
  [GETTER_TYPES.BASKET_BASKET_ORDER_POST_URL]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'orderPostUrl']),
  [GETTER_TYPES.BASKET_BASKET_SELF_POST_URL]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'selfPostUrl']),
  [GETTER_TYPES.BASKET_BASKET_SELF_PATCH_URL]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'selfPatchUrl']),
  [GETTER_TYPES.BASKET_BASKET_PRODUCT_POST_URL]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketProductPostUrl']),
  [GETTER_TYPES.BASKET_BASKET_ADDRESS_POST_URL]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketAddressPostUrl']),
  [GETTER_TYPES.BASKET_BASKET_SERVICE_POST_URL]: state =>
    get(state, [[MUTATION_TYPES.BASKET.dataKey], 'basketServicePostUrl']),
  [GETTER_TYPES.BASKET_BASKET_PAYMENT_ADDRESS_DELETE_URL]: (state, getters) => {
    return getters[GETTER_TYPES.BASKET_PAYMENT_ADDRESS_INCLUDED].reduce((addresses, address) => {
      const allowed = getLinkAllowedOfType(
        get(address, API_CONSTANTS.LINKS, {}),
        API_CONSTANTS.LINK.SELF,
      )
      if (Array.isArray(allowed) && allowed.includes('DELETE')) {
        addresses.push(
          getLinkUrlOfType(get(address, API_CONSTANTS.LINKS, {}), API_CONSTANTS.LINK.SELF),
        )
      }
      return addresses
    }, [])
  },
  [GETTER_TYPES.BASKET_BASKET_DELIVERY_ADDRESS_DELETE_URL]: (state, getters) => {
    return getters[GETTER_TYPES.BASKET_DELIVERY_ADDRESS_INCLUDED].reduce((addresses, address) => {
      const allowed = getLinkAllowedOfType(
        get(address, API_CONSTANTS.LINKS, {}),
        API_CONSTANTS.LINK.SELF,
      )
      if (Array.isArray(allowed) && allowed.includes('DELETE')) {
        addresses.push(
          getLinkUrlOfType(get(address, API_CONSTANTS.LINKS, {}), API_CONSTANTS.LINK.SELF),
        )
      }
      return addresses
    }, [])
  },
  [GETTER_TYPES.BASKET_BASKET_PAYMENT_SERVICE_DELETE_URL]: (state, getters) => {
    return getters[GETTER_TYPES.BASKET_PAYMENT_SERVICE_INCLUDED].reduce((urls, service) => {
      const allowed = getLinkAllowedOfType(
        get(service, API_CONSTANTS.LINKS, {}),
        API_CONSTANTS.LINK.SELF,
      )
      if (Array.isArray(allowed) && allowed.includes('DELETE')) {
        urls.push(getLinkUrlOfType(get(service, API_CONSTANTS.LINKS, {}), API_CONSTANTS.LINK.SELF))
      }
      return urls
    }, [])
  },
  [GETTER_TYPES.BASKET_BASKET_DELIVERY_SERVICE_DELETE_URL]: (state, getters) => {
    return getters[GETTER_TYPES.BASKET_DELIVERY_SERVICE_INCLUDED].reduce((urls, service) => {
      const allowed = getLinkAllowedOfType(
        get(service, API_CONSTANTS.LINKS, {}),
        API_CONSTANTS.LINK.SELF,
      )
      if (Array.isArray(allowed) && allowed.includes('DELETE')) {
        urls.push(getLinkUrlOfType(get(service, API_CONSTANTS.LINKS, {}), API_CONSTANTS.LINK.SELF))
      }
      return urls
    }, [])
  },
})
